import styled from "styled-components";
import { spacingHelper, typographyHelper } from "../../../utils";
import Label from "../../Label";
import { transition } from "../../../private/helpers";
var heightHelper = _ref => {
  var {
    theme,
    $sizeVariant
  } = _ref;
  var {
    spacing
  } = theme;
  var height = {
    large: spacing.extraLarge,
    medium: spacing.large,
    small: spacing.large
  };
  return height[$sizeVariant] || spacing.extraLarge;
};
var marginBottomHelper = _ref2 => {
  var {
    $sizeVariant,
    theme
  } = _ref2;
  var {
    spacing
  } = theme;
  var margins = {
    large: spacing.extraSmall,
    medium: spacing.extraSmall,
    small: spacing.twoExtraSmall
  };
  return margins[$sizeVariant];
};
var StyledLabel = styled(Label).withConfig({
  displayName: "styles__StyledLabel",
  componentId: "sc-l614ls-0"
})(["margin-bottom:", ";"], spacingHelper("twoExtraSmall"));
var ChevronWrapper = styled.div.withConfig({
  displayName: "styles__ChevronWrapper",
  componentId: "sc-l614ls-1"
})(["align-items:center;display:flex;height:", ";margin-left:", ";pointer-events:none;transition:", ";", " ", ""], heightHelper, spacingHelper("medium"), transition("transform"), _ref3 => {
  var {
    $isOpen
  } = _ref3;
  return $isOpen && "transform: rotate(-180deg)";
}, _ref4 => {
  var {
    $disabled,
    theme
  } = _ref4;
  return $disabled && "color: " + theme.palette.textDisabled + ";";
});
var IconWrapper = styled.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-l614ls-2"
})(["margin-right:", ";align-items:center;display:flex;height:", ";", ""], _ref5 => {
  var {
    $sizeVariant,
    theme
  } = _ref5;
  return $sizeVariant === "small" ? theme.spacing.small : theme.spacing.medium;
}, heightHelper, _ref6 => {
  var {
    $disabled,
    theme
  } = _ref6;
  return $disabled && "color: " + theme.palette.textDisabled + ";";
});
var ComponentContainer = styled.div.withConfig({
  displayName: "styles__ComponentContainer",
  componentId: "sc-l614ls-3"
})(["text-align:left;position:relative;& > * + *{position:relative;cursor:pointer;}"]);
var DisplayContainer = styled.div.withConfig({
  displayName: "styles__DisplayContainer",
  componentId: "sc-l614ls-4"
})(["text-align:left;overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis;width:100%;margin-bottom:", ";height:", ";", " & > *{", ";", " line-height:", ";}"], marginBottomHelper, heightHelper, _ref7 => {
  var {
    $sizeVariant
  } = _ref7;
  return typographyHelper($sizeVariant === "small" ? "body02" : "body01");
}, _ref8 => {
  var {
    $isPlaceholder,
    theme
  } = _ref8;
  return $isPlaceholder && "color: " + theme.palette.textSecondary + ";";
}, _ref9 => {
  var {
    $disabled,
    theme
  } = _ref9;
  return $disabled && "color: " + theme.palette.textDisabled + ";";
}, heightHelper);
export { StyledLabel, ChevronWrapper, IconWrapper, DisplayContainer, ComponentContainer };